export default __webpack_public_path__ + "static/media/logo-dark.f6bd56ea.svg";